// removed by extract-text-webpack-plugin
module.exports = {"helpText":"_3yvWe","wrapper":"_2WUFs","backButton":"_2pjTp","buttonWrapper":"_3wAaR"};


//////////////////
// WEBPACK FOOTER
// ./containers/stages/MultipleAddressStage/styles.scss
// module id = 764
// module chunks = 0